import React, { useState } from "react";
import { Box, Typography, Button, Container, AppBar, Toolbar, useTheme, useMediaQuery, Grid, List, ListItem, ListItemText, ListItemIcon, Drawer } from "@mui/material";
import vectorCheck from "../assets/images/vector_checkai.png";
import { useNavigate, Link, useParams } from "react-router-dom";
import { Helmet } from "react-helmet";
import boingoLogoWhite from "../assets/images/Boingo-Logo-White.svg";
import fiberLogo from "../assets/images/Boingo-Fiber-Logo.svg";
import signInIcon from "../assets/images/Sign-In-Mobile.svg";
import "../assets/stylesheets/landing.css";
import "../assets/stylesheets/storefront.css";
import { STOREFRONT_CONTENT } from "../assets/const/constant";
import VenueSelector from "../components/VenueSelector";
import { useVenueData } from "../context/VenueDataContext";
import { resolveVenueDisplayData } from "../utils/utils";
import { RouterModal } from "../components/RouterModal";
import { getSelfcareUrl } from "../config/config";
import LinkWithQuery from "../components/LinkWithQuery";
import CloseIcon from "@mui/icons-material/Close";


// Import router images
import routerTPLinkAX10 from "../assets/images/Router-TP-Link-AX10.jpg";
import routerTPLinkAX21 from "../assets/images/Router-TP-Link-AX21.jpg";
import routerASUSAX1800 from "../assets/images/Router-ASUS-AX1800.jpg";
import routerLinksysMR7350 from "../assets/images/Router-Linksys-MR7350.jpg";
import routerTPLinkAX3000 from "../assets/images/Router-TP-Link-AX3000.jpg";
import routerTPLinkWiFi7 from "../assets/images/Router-TP-Link-Wi-Fi-7.jpg";

// Import store icons
import iconAmazon from "../assets/images/Icon-Amazon.svg";
import iconBestBuy from "../assets/images/Icon-Best-Buy.svg";
import iconExchange from "../assets/images/Icon-Exchange.svg";
import iconTarget from "../assets/images/Icon-Target.svg";
import iconWalmart from "../assets/images/Icon-Walmart.svg";
import { content } from "../assets/const/content";

// Router image mapping by name
const routerImages = {
    "TP-Link AX10": routerTPLinkAX10,
    "TP-Link AX21": routerTPLinkAX21,
    "ASUS AX1800": routerASUSAX1800,
    "Linksys MR7350": routerLinksysMR7350,
    "TP-Link AX3000": routerTPLinkAX3000,
    "TP-Link Wi-Fi 7": routerTPLinkWiFi7,
};

// Store icon mapping by name
const storeIcons = {
    "amazon": iconAmazon,
    "bestbuy": iconBestBuy,
    "exchange": iconExchange,
    "target": iconTarget,
    "walmart": iconWalmart,
};

// Navbar component
const Navbar = () => {
    const [mobileOpen, setMobileOpen] = useState(false);
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  
    const handleDrawerToggle = () => {
      setMobileOpen(!mobileOpen);
    };
  
    const drawer = (
      <Box data-test-id="mobile-nav-drawer">
        <Box className="mobile-nav-container" onClick={handleDrawerToggle}>
          <img src={fiberLogo} />
          <CloseIcon className="close-icon" />
        </Box>
  
        <Box className="mobile-nav-sub-section" data-test-id="mobile-nav-sub-section">
          <Typography className="lets-start">
            {/* Let&#8217;s start by finding out
            <br /> if Boingo Fiber is available <br /> in your home */}
          </Typography>
          <LinkWithQuery to="/signup-form" className="avail-btn">
            Sign Up Now
          </LinkWithQuery>
        </Box>
        <Box className="mobile-nav-hr"></Box>
        <Box className="mobile-sign-in-wrapper" data-test-id="mobile-sign-in-wrapper">
          <a href={getSelfcareUrl(window.location.host)}>
            <img src={signInIcon} />
            Log in to my account
          </a>
        </Box>
      </Box>
    );
  
    const [loginModalOpen, setLoginModalOpen] = useState(false);
  
    const handleLoginClick = () => {
      setLoginModalOpen(true);
    };
  
    const handleLoginClose = () => {
      setLoginModalOpen(false);
    };
  
    return (
      <Box data-test-id="nav-container">
        <AppBar
          position="fixed"
          className="app-bar"
          sx={{ backgroundColor: "rgb(44, 46, 55)" }}
        >
          <Toolbar>
            {isMobile ? (
              <>
                {/* Mobile Navigation */}
                <Box
                  className="mobile-nav"
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    width: "100%",
                    padding: "0 8px",
                  }}
                  data-test-id="mobile-nav"
                >
                  <Box
                    sx={{
                      width: "55%",
                      display: "flex",
                      justifyContent: "flex-start",
                    }}
                  >
                    <img src={boingoLogoWhite} className="fiber-logo" />
                  </Box>
                  <Box
                    sx={{
                      width: "33%",
                      padding:"5px 0px",
                      display: "flex",
                      justifyContent: "flex-end",
                      marginLeft: 3,
                    }}
                  >
                    <Button
                      component="a"
                      href={getSelfcareUrl(window.location.host)}
                      sx={{
                        fontSize: "16px",
                        color: "rgba(255, 255, 255, 1)",
                        border: "1px solid rgba(255, 255, 255, 0.4)",
                        borderRadius: "8px",
                        padding: "2px 24px",
                        "&:hover": {
                          background: "var(--greyBg)",
                          border: "1px solid white",
                          transition: "all .3s ease-in-out",
                        },
                      }}
                    >
                      Log in to my account
                    </Button>
                  </Box>
                  <Drawer
                    variant="temporary"
                    open={mobileOpen}
                    anchor="right"
                    onClose={handleDrawerToggle}
                    ModalProps={{ keepMounted: true }}
                  >
                    {drawer}
                  </Drawer>
                </Box>
              </>
            ) : (
              <Container
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  width: "75%",
                  flexFlow: "row",
                  "&.MuiContainer-root": { maxWidth: "1500px" },
                }}
              >
                <Grid
                  sx={{
                    width: "auto",
                    alignSelf: "flex-start",
                  }}
                >
                  <Grid
                    item
                    sx={{
                      textAlign: "right",
                      width: "300px",
                      display: "flex",
                      justifyContent: "flex-start",
                    }}
                  >
                    <Box sx={{ width: "30%", mt: 1 }}>
                      <img src={boingoLogoWhite} className="footer-logo" />
                    </Box>
                  </Grid>
                </Grid>
                <Grid
                  sx={{
                    justifyContent: "flex-end",
                    display: "flex",
                  }}
                >
                  <Grid
                    sx={{
                      display: "flex",
                      width: "300px",
                      flexFlow: "row wrap",
                      alignSelf: "flex-end",
                      justifyContent: "flex-end",
                    }}
                  >
                    <Button
                      component="a"
                      href={getSelfcareUrl(window.location.host)}
                      sx={{
                        fontSize: "16px",
                        border: "1px solid rgba(255, 255, 255, 0.4)",
                        borderRadius: "8px",
                        padding: "2px 24px",
                        color: "rgba(255, 255, 255, 1)",
                        ":hover": {
                          backgroundColor: '#000'
                        }
                      }}
                    >
                      Log in to my account
                    </Button>
                  </Grid>
                </Grid>
              </Container>
            )}
          </Toolbar>
        </AppBar>
        <Toolbar />
      </Box>
    );
  };

// HeroSection component
const HeroSection = () => {

    return (
        <>
            <Box
                className="hero-section storefront-hero-section"
                data-test-id="hero-section-container"
                sx={{
                    overflow: "hidden",
                }}
            >
                <Box className="hero-img storefront-hero-img" ></Box>
            </Box>
        </>
    )
};

// Footer component
const Footer = () => {
    const currentYear = new Date().getFullYear();

    return (
        <Box
            className="landing-page-footer-section"
            data-test-id="landing-page-footer-section"
            sx={{ backgroundColor: "rgb(44, 46, 55)" }}
        >
            <img src={boingoLogoWhite} className="footer-logo" alt="logo" />

            <Box className="footer-links-wrapper">
                <Box className="footer-links">
                    <Link
                        to="https://www.boingo.com/legal/boingo-privacy-policy/"
                        target="_blank"
                        data-test-id="landing-page-privacy-link"
                    >
                        Privacy policy
                    </Link>{" "}
                    <span style={{ color: "rgba(175, 177, 181, 0.9)" }}>&nbsp;|&nbsp;&nbsp;</span>
                    <Link
                        target="_blank"
                        to="https://www.boingo.com/legal/website-terms-use-acceptable-use-policy/"
                        data-test-id="landing-page-terms-link"
                    >
                        Terms of use
                    </Link>{" "}
                    <span style={{ color: "rgba(175, 177, 181, 0.9)" }}>&nbsp;|&nbsp;&nbsp;</span>
                    <Link
                        target="_blank"
                        to="https://www.boingo.com/legal/cookie-policy/"
                        data-test-id="landing-page-cookie-link"
                    >
                        Cookie policy
                    </Link>
                </Box>

                <Typography color="rgba(175, 177, 181, 0.9)">
                    Boingo customer support is available 24/7/365.
                </Typography>

                <Typography color="rgba(175, 177, 181, 0.9)" data-test-id="landing-page-copyright">
                    &copy; {currentYear} Boingo Wireless, Inc. All rights reserved.
                </Typography>
            </Box>
        </Box>
    );
};

const StoreFront = () => {
    const navigate = useNavigate();
    const { venueId } = useParams();
    const { venues } = useVenueData();
    const venueData = resolveVenueDisplayData(venueId, venues);
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("md"));
    
    // Router modal state
    const [selectedRouter, setSelectedRouter] = useState(null);
    const [isRouterModalOpen, setIsRouterModalOpen] = useState(false);

    const handleRouterClick = (router) => {
        setSelectedRouter(router);
        setIsRouterModalOpen(true);
    };

    const handleCloseRouterModal = () => {
        setIsRouterModalOpen(false);
        setSelectedRouter(null);
    };

    return (
        <>
            <Helmet>
                <title>{STOREFRONT_CONTENT.HEADER_TEXT}</title>
            </Helmet>
            <Navbar/>
            <HeroSection />
            <Container maxWidth="md" className="storefront-main-container"
                sx={{
                    padding: isMobile ? "0 25px" : "0px",
                    marginTop:"40px"
                }}
            >
                <Box className="storefront-content-box">
                    <Typography variant="h3" fontFamily="Figtree-Bold" gutterBottom
                        sx={{
                            color: "var(--darkblue)",
                            fontSize: isMobile ? "2rem" : "2.5rem",
                            lineHeight: "1.2",
                            letterSpacing: "0.01em",
                            textAlign: "center",
                            marginBottom:"30px",
                        }}>
                        {STOREFRONT_CONTENT.HEADER_TEXT}
                    </Typography>
                    <Typography variant="h6" color="text.secondary"
                        sx={{
                            fontFamily: "Figtree-Bold",
                            color: "var(--greyBg)",
                            fontSize: isMobile ? "1.2rem" : "1.3rem",
                        }}>
                        {STOREFRONT_CONTENT.SUB_HEADER_TEXT}
                    </Typography>
                    <Box className="storefront-list-container">
                        <Typography variant="body1"
                            sx={{
                                color: "var(--greyBg)",
                                textAlign: "center",
                                marginBottom: "16px",
                            }}
                        >
                            {STOREFRONT_CONTENT.PRE_LIST_TEXT}
                        </Typography>

                        <List className="storefront-specs-list"
                            sx={{
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "flex-start",
                                gap: "0px",
                                width: "310px",
                            }}
                        >
                            {STOREFRONT_CONTENT.LIST_TEXT.map((item, index) => (
                                <ListItem key={index} className="storefront-list-item"
                                    sx={{
                                        height: "auto",
                                        padding: "0px",
                                    }}
                                >
                                    <ListItemIcon
                                        sx={{
                                            minWidth: "20px",
                                            marginRight: "8px",
                                            marginTop: "2px",
                                        }}
                                    >
                                        <img src={vectorCheck} alt="checkmark" className="storefront-checkmark" />
                                    </ListItemIcon>
                                    <ListItemText
                                        primary={item}
                                        className="storefront-list-text"
                                    />
                                </ListItem>
                            ))}
                        </List>
                        <Typography variant="body1"
                            sx={{
                                color: "var(--grey)",
                                textAlign: "center",
                                margin: "20px 16px",
                            }}
                        >
                            {STOREFRONT_CONTENT.POST_LIST_TEXT}
                        </Typography>
                    </Box>
                </Box>
                <Box className="storefront-router-list-container"
                    sx={{
                        justifyContent: isMobile ? "space-evenly" : "space-between",
                        width: isMobile ? "100%" : "auto",
                    }}>
                    <Typography variant="h3" fontFamily="Figtree-Bold" gutterBottom className="storefront-header-text">
                        {STOREFRONT_CONTENT.ROUTER_HEADER_TEXT}
                    </Typography>

                    {/* Routers Grid Section */}
                    {STOREFRONT_CONTENT.ROUTER_MODELS && (
                        <Box className="storefront-router-grid"
                            sx={{
                                gap: isMobile ? "20px" : "20px",
                                marginTop: isMobile ? "10px" : "0px",
                                flexFlow: isMobile ? "column" : "row wrap"
                            }}
                        >
                            {STOREFRONT_CONTENT.ROUTER_MODELS.map((router, idx) => (
                                <Box 
                                    key={router.name} 
                                    className="storefront-router-card"
                                    onClick={() => handleRouterClick(router)}
                                    sx={{
                                        cursor: "pointer",
                                        transition: "transform 0.2s ease, box-shadow 0.2s ease",
                                        maxWidth: isMobile ? "100%" : "31.5%",
                                        "&:hover": {
                                            transform: "translateY(-2px)",
                                            boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
                                        }
                                    }}
                                >
                                    <Box className="storefront-router-image-container">
                                        <img
                                            src={routerImages[router.name]}
                                            alt={router.name}
                                            className="storefront-router-image"
                                        />
                                    </Box>
                                    <Typography variant="subtitle1" className="storefront-router-name"
                                        sx={{
                                            color: "var(--grey)",
                                            fontFamily: "Figtree-Bold",
                                            marginTop: "10px"
                                        }}>
                                        {router.name}
                                    </Typography>
                                    <Typography variant="body2" className="storefront-buy-now-text"
                                        sx={{
                                            color: "var(--blue)",
                                            fontFamily: "Figtree-Bold",
                                            fontSize: "1rem",
                                            textAlign: "center",
                                            marginBottom: "8px",
                                        }}>
                                        {STOREFRONT_CONTENT.BUY_NOW_TEXT}
                                    </Typography>
                                    <Box className="storefront-store-links">
                                        {router.links.map((link, lidx) =>
                                            link.link ? (
                                                <Box key={link.name} className="storefront-store-link">
                                                    <img
                                                        src={storeIcons[link.name]}
                                                        alt={link.name}
                                                        className="storefront-store-icon"
                                                    />
                                                </Box>
                                            ) : (
                                                <Box key={link.name} className="storefront-placeholder-icon">
                                                    {/* Placeholder for missing link */}
                                                </Box>
                                            )
                                        )}
                                    </Box>
                                </Box>
                            ))}
                        </Box>
                    )}

                    {/* Additional Router Options */}
                    <Box className="storefront-additional-options">
                        <Typography variant="subtitle1" className="storefront-additional-options-text"
                            sx={{
                                color: "var(--grey)",
                                fontFamily: "Figtree-Bold",
                            }}>
                            {STOREFRONT_CONTENT.ADDITIONAL_ROUTER_HEADER_TEXT}
                        </Typography>
                        <List className="storefront-additional-options-list"
                            sx={{
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center",
                                gap: "0px",
                                justifyContent: "center",

                            }}>
                            {STOREFRONT_CONTENT.ADDITIONAL_ROUTER_LIST_TEXT.map((item, index) => (
                                <ListItem key={index} className="storefront-additional-options-list-item"
                                    sx={{
                                        height: "auto",
                                        padding: "0px",
                                        textAlign: "center",
                                    }}>
                                    <ListItemText
                                        primary={item}
                                        className="storefront-additional-options-list-text"
                                        sx={{
                                            margin:"0px auto",
                                        }}
                                    />
                                </ListItem>
                            ))}
                        </List>
                    </Box>
                </Box>
                <Box className="storefront-signup-container">
                    <Typography variant="h3" fontFamily="Figtree-Bold" gutterBottom className="storefront-header-text"
                        sx={{
                            color: "var(--grey)",
                            fontSize: "2.5rem",
                            lineHeight: "1.2",
                            letterSpacing: "0.01em",
                            textAlign: "center",
                            padding:"5px 0px",
                        }}
                    >
                        {content.header} {content.header2}
                    </Typography>
                    <Box>
                        <VenueSelector
                            className="venue-selector-store"
                            customStyles={{
                                padding: "10px 60px",
                                borderRadius: "7px",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                margin: "0 auto",
                                width: "300px",
                                alignSelf: "center",
                            }}
                        />
                    </Box>
                    <Typography variant="body1" className="storefront-signup-post-text"
                        sx={{
                            color: "var(--grey)",
                            textAlign: "center",
                            fontFamily:"Figtree-Bold",
                            marginTop:"20px",
                            fontSize:"1.25rem",
                        }}
                    >
                        {STOREFRONT_CONTENT.SIGNUP_POST_TEXT}
                    </Typography>
                </Box>
                <Box
                    className="plan-container"
                    sx={{
                        width:isMobile ? "90%" : "400px",
                        margin:"0 auto 40px auto",
                        padding:"10px 0px 20px 0px",
                        border:"5px solid var(--lightgrey)",
                        height:isMobile ? "330px" : "360px",
                    }}
                >
                    <Box
                        className="plan-wrap"
                    >
                        <Typography className="plan-title">
                            {venueData?.plan_name}
                        </Typography>
                        <Box className="description-wrap">
                            <Box className="desc-row"
                                sx={{
                                    marginTop:isMobile ? "0px" : "10px",
                                    marginBottom:isMobile ? "15px" : "0px",
                                }}
                            >
                                <Box className="price-wrapper" sx={{ marginBottom: isMobile ? "-32px" : "" }}>
                                    <Typography className="price">
                                        <span className="dollar-sign">$</span>
                                        {venueData?.plan_price}
                                        <span className="duration">/mo</span>
                                    </Typography>
                                </Box>
                            </Box>
                            <Box>
                                <ul
                                    className="plan-details-list"
                                    style={{
                                        margin:"0px auto",
                                    }}
                                >
                                    {(venueData?.module_content?.plan_list_text || []).map((text, index) => (
                                        <li key={index}>
                                            <img className="check" src={vectorCheck} />
                                            <span>{text}</span>
                                        </li>
                                    ))}
                                </ul>
                            </Box>
                        </Box>
                    </Box>
                </Box>
            </Container>
            
            {/* Router Modal */}
            <RouterModal
                open={isRouterModalOpen}
                onClose={handleCloseRouterModal}
                router={selectedRouter}
                routerImages={routerImages}
                storeIcons={storeIcons}
            />
            
            <Footer />
        </>
    );
};

export default StoreFront;
